import {createRouter, createWebHistory} from 'vue-router';

import User from '@/views/admin/pages/lichHop/index.vue'

const routes = [


/**************** Frontend  *************/

    {
        path: '/',
        name: '',
        component: User,
    },
    

]


export const router = createRouter({
    history: createWebHistory('/'),
    linkActiveClass: 'active',
    routes,
});

router.beforeEach((to, from, next) => {
// Scroll to the top of the page
window.scrollTo({ top: 0, behavior: 'smooth' });

// Continue with the navigation
next();
});
